// Use if the event should trigger a chat invite
export enum ChatBotProactiveEventNames {
  failedLogin = 'failed_login',
  guestPayError = 'guest_pay_error',
  goodQuoteProspect = 'good_quote_prospect'
}

// Use if the event should not trigger a chat invite
export enum ChatBotCustomEventNames {
  isEASQuote = 'quote_is_eas'
}

export type ChatBotEventName = ChatBotProactiveEventNames | ChatBotCustomEventNames;
